import { makeRouteTel } from '@w/tel'
import { ms } from '@w/utils'
import { UserActivityTracker } from './user-activity-tracker.js'

export interface HybridTracingConfig {
  timeoutMinutes?: number
}

export interface HybridTracingManager {
  startNewTrace: () => void
  initHybridTracing: () => void
}

export function createHybridTracingManager(config: HybridTracingConfig = {}): HybridTracingManager {
  const { timeoutMinutes = 10 } = config
  let lastTraceStart = 0

  function startNewTrace() {
    makeRouteTel(window.location.pathname) // in SB first window.location.pathname = /, then BaseFakeAppRouter sets initialEntires[0]
    lastTraceStart = Date.now()
  }

  function initHybridTracing() {
    // Initialize activity tracker for Rule 2: Start new trace after user inactivity
    new UserActivityTracker({
      onInactivity: () => startNewTrace(),
    })

    // Periodic check for Rule 1: configurable timeout (default 10 minutes)
    setInterval(() => {
      const now = Date.now()
      const timeSinceLastTrace = now - lastTraceStart

      if (timeSinceLastTrace >= timeoutMinutes * ms.min) {
        startNewTrace()
      }
    }, 60 * 1000) // Check every minute
  }

  return {
    startNewTrace,
    initHybridTracing,
  }
}
